export { default } from './BottomNavigation';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/BottomNavigation/index.js
// module id = 639
// module chunks = 0